import { Injectable } from '@angular/core';
import {
  ConsentExpressDTOReturn,
  ConsentExpressRequestDTO,
  IntervenersDigitalSignatureDTO,
  IntervenientsDTO,
} from '@app/requests/model/logalty-signature-model';
import { Operation } from '@app/requests/model/requests-model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DigitalSignatureCommonService {
  private _participantsListObserver: BehaviorSubject<IntervenersDigitalSignatureDTO> = new BehaviorSubject(undefined);
  private _sessionDataLogaltyObserver: BehaviorSubject<ConsentExpressDTOReturn> = new BehaviorSubject(undefined);
  private _cancelConsentsObserver: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _OperationObserver: BehaviorSubject<Operation> = new BehaviorSubject(undefined);
  private _participantObserver: BehaviorSubject<IntervenientsDTO> = new BehaviorSubject(undefined);
  private _sessionIdObserver: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private _dataAsyncSignatureObserver: BehaviorSubject<ConsentExpressRequestDTO> = new BehaviorSubject(undefined);
  private _userHostId: BehaviorSubject<string> = new BehaviorSubject(undefined);

  public setParticipantList(item: IntervenersDigitalSignatureDTO) {
    this._participantsListObserver.next(item);
  }

  public ParticipantsListObserver(): Observable<IntervenersDigitalSignatureDTO> {
    return this._participantsListObserver.asObservable();
  }

  public setSessionDataLogalty(item: ConsentExpressDTOReturn) {
    this._sessionDataLogaltyObserver.next(item);
  }

  public SessionDataLogaltyObserver(): ConsentExpressDTOReturn {
    return this._sessionDataLogaltyObserver.getValue();
  }

  public setCancelConsents(item: boolean) {
    this._cancelConsentsObserver.next(item);
  }

  public CancelConsents(): boolean {
    return this._cancelConsentsObserver.getValue();
  }

  public setParticipant(item: IntervenientsDTO) {
    this._participantObserver.next(item);
  }

  public getParticipant(): IntervenientsDTO {
    return this._participantObserver.getValue();
  }

  public setOperation(item: Operation) {
    localStorage.setItem('Operation', JSON.stringify(item));
    this._OperationObserver.next(item);
  }

  public getOperation(): Operation {
    return this._OperationObserver.getValue()
      ? this._OperationObserver.getValue()
      : JSON.parse(localStorage.getItem('Operation'));
  }

  public setSessionId(item: string) {
    this._sessionIdObserver.next(item);
  }

  public getSessionId(): string {
    return this._sessionIdObserver.getValue();
  }

  public setNumOperationSignature(numOperation: string) {
    localStorage.setItem('numOperationSignature', numOperation);
  }

  public getNumOperationSignature() {
    return localStorage.getItem('numOperationSignature');
  }

  public setGUIDSignature(guid: string) {
    localStorage.setItem('GUID', guid);
  }

  public getGUIDSignature() {
    return localStorage.getItem('GUID');
  }

  public setDataAsynsSignatureObserver(item: ConsentExpressRequestDTO) {
    return this._dataAsyncSignatureObserver.next(item);
  }

  public getDataAsynSignature(): ConsentExpressRequestDTO {
    return this._dataAsyncSignatureObserver.getValue();
  }

  public setAssyncUserHostId(userHostId: string) {
    this._userHostId.next(userHostId);
  }

  public getAssyncUserHostId(): string {
    return this._userHostId.getValue();
  }
}
